import SearchDropdown from "../../input/SearchDropdown";

import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { missionControlActions } from "../../../store/mission-control/mission-control-slice";
import LoadingSpinner from "../../LoadingSpinner";
import Button from "../../input/Button";
import {
  filterGpsVehicles,
  getVehicleJob,
  fetchBatchVehicleJobs,
  getCustomersSearchDropdown,
  getDestinationsSearchDropdown,
  getVehiclesSearchDropdown,
  getJobsSearchDropdown
} from "../../../api/missioncontrolApi";
import Modal from "../../Modal";
import ResultOptions from "./ResultOptions";
import UiLabelList from "../../input/UiLabelList";
import { searchFilterConst, searchFilterKeyValue } from "../../../const";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import { errorMessageToast } from "../../../helper";

const SearchFiltration = ({ eventOptions, isLoading, jobStatusOptions }) => {
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [results, setResults] = useState([]);
  const modalRef = useRef(null);

  const closeModal = () => {
    modalRef.current.close();
  };

  const searchFilters = useSelector(
    (state) => state.missionControl.searchFilters,
  );

  const markerLimit = useSelector(
    (state) => state.missionControl.mapSettings.markerLimit,
  );

  const labelSelectHandler = (value) => {
    dispatch(missionControlActions.addOrRemoveFromFilter(value));
  };

  const filterList = useSelector((state) => state.missionControl.filterList);

  const dispatch = useDispatch();

  const onResultSelect = (data, type) => {
    dispatch(
      missionControlActions.addToSearchFilter({
        type,
        key: data.key,
        value: data.title,
      }),
    );
  };

  const multiValueRemoveHandler = (id, type) => {
    dispatch(
      missionControlActions.removeFromSearchFilter({
        type,
        id,
      }),
    );
  };

  const filterHandler = async () => {
    setIsFilterLoading(true);
    dispatch(
      missionControlActions.setResults({
        results: [],
        jobInfo: {},
      }),
    );
    const response = await filterGpsVehicles({
      job: Object.keys(searchFilters.job).join(","),
      stakeholder: Object.keys(searchFilters.stakeholder).join(","),
      vehicle: Object.keys(searchFilters.vehicle).join(","),
      destination: Object.keys(searchFilters.destination).join(","),
      eventType:
        searchFilters.eventType && searchFilters.eventType.length > 0
          ? searchFilters.eventType.join(",")
          : "",
      jobStatus: searchFilters.jobStatus,
      fromDate: searchFilters.fromDate || null,
      toDate: searchFilters.toDate || null,
    });

    if (!response || !Array.isArray(response)) {
      setIsFilterLoading(false);
      return;
    }

    if (response && response.length > markerLimit) {
      setResults(response);
      modalRef.current?.showModal();
    } else {
      const jobInfo = await fetchBatchVehicleJobs(response);
      dispatch(
        missionControlActions.setResults({
          results: response,
          jobInfo,
        }),
      );
    }
    setIsFilterLoading(false);
  };

  const filterComponentMap = {
    [searchFilterConst.CUS]: (
      <SearchDropdown
        key={1}
        editMode={false}
        occupySpace={false}
        reset={resetSearchFields}
        setReset={setResetSearchFields}
        returnFullObject={true}
        onResultSelect={(data) => onResultSelect(data, "stakeholder")}
        multiValueRemoveHandler={(key) => {
          multiValueRemoveHandler(key, "stakeholder");
        }}
        multiValueTwoWayBinding={true}
        multiValues={searchFilters.stakeholder}
        api={getCustomersSearchDropdown}
        apiDependency={{}}
        multiple={true}
        label="Customer"
      />
    ),
    [searchFilterConst.JOB]: (
      <SearchDropdown
        key={1}
        editMode={false}
        occupySpace={false}
        reset={resetSearchFields}
        setReset={setResetSearchFields}
        returnFullObject={true}
        onResultSelect={(data) => onResultSelect(data, "job")}
        multiValueRemoveHandler={(key) => {
          multiValueRemoveHandler(key, "job");
        }}
        multiValueTwoWayBinding={true}
        multiValues={searchFilters.job}
        api={getJobsSearchDropdown}
        apiDependency={{}}
        multiple={true}
        label="Job"
      />
    ),
    [searchFilterConst.VEH]: (
      <SearchDropdown
        key={1}
        editMode={false}
        occupySpace={false}
        reset={resetSearchFields}
        setReset={setResetSearchFields}
        returnFullObject={true}
        onResultSelect={(data) => onResultSelect(data, "vehicle")}
        multiValueRemoveHandler={(key) => {
          multiValueRemoveHandler(key, "vehicle");
        }}
        multiValueTwoWayBinding={true}
        multiValues={searchFilters.vehicle}
        api={getVehiclesSearchDropdown}
        apiDependency={{}}
        multiple={true}
        label="Vehicle"
      />
    ),
    [searchFilterConst.LOC]: (
      <SearchDropdown
        key={1}
        editMode={false}
        occupySpace={false}
        reset={resetSearchFields}
        setReset={setResetSearchFields}
        returnFullObject={true}
        onResultSelect={(data) => onResultSelect(data, "destination")}
        multiValueRemoveHandler={(key) => {
          multiValueRemoveHandler(key, "destination");
        }}
        multiValueTwoWayBinding={true}
        multiValues={searchFilters.destination}
        api={getDestinationsSearchDropdown}
        apiDependency={{}}
        multiple={true}
        label="Destination"
      />
    ),
    [searchFilterConst.EVENT_TYPE]: (
      <Dropdown
        style={{
          outline: "none",
          height: "20px",
          boxShadow:
            " 0 4px 8px rgba(0, 0, 0, 0.1),0 6px 20px rgba(0, 0, 0, 0.1)",
        }}
        error={errors.eventType}
        resetError={() =>
          setErrors((prev) => {
            const { eventType, ...rest } = prev;
            return rest;
          })
        }
        options={eventOptions}
        label="Event Type"
        value={searchFilters.eventType}
        multiple={true}
        onChange={(e, data) => {
          dispatch(missionControlActions.setEvents(data.value));
        }}
      />
    ),
    [searchFilterConst.JOB_STATUS]: (
      <Dropdown
        style={{
          outline: "none",
          height: "20px",
          boxShadow:
            " 0 4px 8px rgba(0, 0, 0, 0.1),0 6px 20px rgba(0, 0, 0, 0.1)",
        }}
        error={errors.jobStatus}
        resetError={() =>
          setErrors((prev) => {
            const { jobStatus, ...rest } = prev;
            return rest;
          })
        }
        options={jobStatusOptions}
        label="Job Status"
        value={searchFilters.jobStatus}
        multiple={true}
        onChange={(e, data) => {
          dispatch(missionControlActions.setJobStatus(data.value));
        }}
      />
    ),
    [searchFilterConst.DATE_RANGE]: (
      <>
        <Input
          type="date"
          value={searchFilters.fromDate}
          label="From Date"
          max={searchFilters.toDate ?? new Date().toISOString().split("T")[0]}
          onChange={(e) => {
            dispatch(missionControlActions.setSearchFromDate(e.target.value));
          }}
        />
        <Input
          type="date"
          disabled={!searchFilters.fromDate}
          min={searchFilters.fromDate ?? null}
          max={new Date().toISOString().split("T")[0]}
          value={searchFilters.toDate}
          label="To Date"
          onChange={(e) => {
            dispatch(missionControlActions.setSearchToDate(e.target.value));
          }}
        />
      </>
    ),
  };

  return (
    <>
      <Modal ref={modalRef} minWidth="1100px" closeButton={true}>
        <ResultOptions results={results} close={closeModal} />
      </Modal>
      <div
        className="ui form"
        style={{
          height: "80.5vh",
          width: "400px",
          borderRadius: "10px",
          background: "transparent",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
        }}
      >
        <div
          className="ui segment"
          style={{
            height: "80.5vh",
            borderRadius: "10px",
            background: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.25)",
            overflow: "scroll",
          }}
        >
          <h4 className="ui dividing header">Search Filters</h4>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <h5 className="ui header">Add or Remove Filters</h5>
              <div className="ui segment">
                <UiLabelList
                  list={searchFilterKeyValue}
                  selectedSet={new Set(filterList)}
                  selectable={true}
                  labelSelectHandler={labelSelectHandler}
                  keyValue={true}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                {filterList.map((f) => (
                  <div key={f}>{filterComponentMap[f]}</div>
                ))}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div className="field" style={{ width: "100%" }}>
                  <Button
                    template="submit"
                    label="Apply"
                    onClick={filterHandler}
                    disabled={markerLimit <= 0}
                    isLoading={isFilterLoading}
                  />
                  <Button
                    template="searchReset"
                    onClick={() => {
                      setResetSearchFields(true);
                      dispatch(missionControlActions.clearSearchFilters());
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SearchFiltration;
